<template>
  <div
    v-if="show"
    class="alert-modal-backdrop"
  >
    <div class="alert-modal">
      <div class="icon-wrapper">
        <i :class="iconClass"></i>
      </div>

      <h4 class="title">
        {{ title }}
      </h4>

      <p class="message">
        {{ message }}
      </p>

      <button
        class="btn btn-dark"
        @click="$emit('close')"
      >
        بستن
      </button>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { computed } from "vue";

const props = defineProps({
  show: Boolean,

  type: {
    type: String,
    default: "success",
  },

  title: String,

  message: String,
});

defineEmits(["close"]);

const iconClass = computed(() => {
  return props.type === "success"
    ? "bi bi-check-circle-fill success-icon"
    : "bi bi-x-circle-fill error-icon";
});
</script>

<style scoped>
.alert-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;
}

.alert-modal {
  width: 380px;
  background: white;
  border-radius: 16px;
  padding: 30px 24px;
  text-align: center;
}

.icon-wrapper {
  margin-bottom: 15px;
}

.icon-wrapper i {
  font-size: 60px;
}

.success-icon {
  color: #198754;
}

.error-icon {
  color: #dc3545;
}

.title {
  margin-bottom: 10px;
  font-weight: 700;
}

.message {
  color: #666;
  margin-bottom: 20px;
}
</style>
